


















































import { Vue, Component, Prop } from 'vue-property-decorator';

import CloseModalIcon from '@/components/icons/CloseModal.vue';
import Typography from '@/componentsV2/atoms/Typography/Typography.vue';
import FilledButton from '@/components/molecules/FilledButton/FilledButton.vue';
import DateUtils from '@/utils/DateUtils';
import { Picture } from '@/components/atoms';
import eventBus from '@/utils/eventBus';
import flagKeys from '@/constants/flagKeys';
import { removeTrailingZeros } from '@/utils/moneyFormarter';
import { ETutorial } from '@/models/tutorial';
import BusinessService from '@/api/BusinessService';
import segmentIo from '@/utils/segment.io';
import { getNeedsOnboardingCall } from '@/utils/onboardingCall';

@Component({
  components: {
    Typography,
    CloseModalIcon,
    FilledButton,
    Picture
  }
})
export default class CoinNetworkWelcomeModal extends Vue {
  @Prop() subscription!: any;
  @Prop({ default: 'Explore dashboard' }) ctaText!: string;
  @Prop() ctaClick?: () => void;

  service = new BusinessService();

  get tPrefix() {
    return 'modals.billing.welcome';
  }

  get link() {
    return 'https://support.twism.com/hc/en-us/articles/21224269134349-The-Coin-Network';
  }

  get flags() {
    return this.$store.getters['flags/getFlags'] || [];
  }

  get billingModuleV3() {
    return this.flags.includes(flagKeys.billingModuleV3);
  }

  get delayedPeriod() {
    return this.billingModuleV3 && this.subscription.eligibleForDelayPeriod;
  }

  get description() {
    return this.$t(`${this.tPrefix}.description.${this.activeBusiness.type}`, {
      locations:
        this.subscription.locations.length > 1
          ? `${this.subscription.locations.length} locations`
          : `location`,
      totalCoins: removeTrailingZeros(this.subscription.totalFee),
      date: this.needsOnboardingCall
        ? `${
            this.subscription.defaultDelayPeriod
          } days after profile activation`
        : DateUtils.formattedDate({
            date: this.delayedPeriod
              ? this.subscription.nextPaymentAt
              : new Date(),
            format: 'MMMM D, YYYY'
          })
    });
  }

  get needsOnboardingCall() {
    return getNeedsOnboardingCall();
  }

  get activeBusiness() {
    return this.$store.getters['business/getBusinessInfo'].business;
  }

  get isImpersonated() {
    return this.$store.getters['manager/isImpersonated'];
  }

  submit() {
    this.onClose();
    if (this.ctaClick) this.ctaClick();
  }

  onClose() {
    eventBus.$emit('closeModal');
  }

  onClickClose() {
    segmentIo.track('Clicked Billing Welcome Close');
    this.onClose();
  }

  onClickLink() {
    segmentIo.track('Clicked Billing Welcome Learn More');
  }

  async created() {
    if (!this.activeBusiness.seenCoinNetworkGuidedTour && !this.isImpersonated)
      await this.service.updateBusinessFlagTutorial({
        state: true,
        flag: ETutorial.SEEN_COIN_NETWORK_GUIDED_TOUR
      });

    segmentIo.modal('Billing Welcome Coin Network');
  }

  destroyed() {
    if (!this.activeBusiness.seenCoinNetworkGuidedTour)
      this.$store.dispatch('business/SET_BUSINESS_INFO', {
        ...this.activeBusiness,
        seenCoinNetworkGuidedTour: true
      });
  }
}
